import React from 'react';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Your consultation',
    desc: 'We map your skin and design your personalized treatment plan.'
  }, {
    num: '2',
    title: 'The session (60–90 min)',
    desc: "Dual-wavelength laser activates your skin's natural repair process."
  }, {
    num: '3',
    title: 'Your reveal (7–10 days)',
    desc: 'As your skin heals, the luminous new you emerges.'
  }];
  return <section className="py-24 md:py-32 bg-background border-t border-divider" data-id="element-126">
      <div className="container mx-auto px-4 md:px-8 max-w-6xl" data-id="element-127">
        <div className="text-center mb-16 md:mb-24" data-id="element-128">
          <h2 className="text-3xl md:text-4xl font-serif text-foreground mb-4" data-id="element-129">
            The Process
          </h2>
          <p className="text-foreground/60 font-sans uppercase tracking-widest text-sm" data-id="element-130">
            Simple. Precise. Transformative.
          </p>
        </div>

        <div className="relative" data-id="element-131">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-[28px] left-[10%] right-[10%] h-[1px] bg-divider z-0" data-id="element-132"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative z-10" data-id="element-133">
            {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center relative" data-id="element-134">
                {/* Connecting line for mobile */}
                {index !== steps.length - 1 && <div className="md:hidden absolute top-[56px] bottom-[-48px] left-1/2 w-[1px] bg-divider -translate-x-1/2 z-[-1]" data-id="element-135"></div>}

                <div className="w-14 h-14 rounded-full bg-background border border-gold text-gold flex items-center justify-center font-serif text-xl mb-8 shadow-[0_0_15px_rgba(184,149,90,0.1)]" data-id="element-136">
                  {step.num}
                </div>

                <h3 className="text-xl font-serif text-foreground mb-4" data-id="element-137">
                  {step.title}
                </h3>
                <p className="text-foreground/70 font-sans leading-relaxed max-w-xs" data-id="element-138">
                  {step.desc}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}